import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Category } from '@work4all/models/lib/Classes/Category.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { CustomerCategoryPicker } from '../../../../components/entity-picker/customer-category-picker/CustomerCategoryPicker';
import { ProjectCategoryPicker } from '../../../../components/entity-picker/project-category-picker/ProjectCategoryPicker';
import { SupplierCategoryPicker } from '../../../../components/entity-picker/supplier-category-picker/SupplierCategoryPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type ICategoryAssignmentFilterCardProps = {
  title: string;
  value: Category[] | null;
  onChange: (value: Category[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
  entityType?: Entities;
};

export const CategoryAssignmentFilterCard: React.FC<
  ICategoryAssignmentFilterCardProps
> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange, entityType } =
    props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    if (value.length === 1) return value[0].name || '';
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      {(() => {
        switch (entityType) {
          case Entities.supplier:
            return (
              <SupplierCategoryPicker
                multiple={true}
                value={value}
                onChange={(newValue) => onChange(newValue || [])}
              />
            );
          case Entities.project:
            return (
              <ProjectCategoryPicker
                multiple={true}
                value={value}
                onChange={(newValue) => onChange(newValue || [])}
              />
            );
          case Entities.customer:
            return (
              <CustomerCategoryPicker
                multiple={true}
                value={value}
                onChange={(newValue) => onChange(newValue || [])}
              />
            );
          default:
            return null;
        }
      })()}
    </FilterCard>
  );
};
